import { z } from "zod";

export const fileUrl = z.string().min(1).max(500).refine(
  (val) => val.startsWith("/uploads/") || val.startsWith("https://"),
  { message: "Fajl mora biti uploadovan, ili link mora počinjati sa https://" }
);

// A real calendar date: the regex alone let "2027-02-30" through and it later
// threw RangeError deep in timezone math (500 instead of 400).
export function isCalendarDate(value: string): boolean {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const [y, m, d] = [Number(match[1]), Number(match[2]), Number(match[3])];
  const t = new Date(Date.UTC(y, m - 1, d));
  return t.getUTCFullYear() === y && t.getUTCMonth() === m - 1 && t.getUTCDate() === d;
}

export const dateString = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, { message: "Datum nije ispravan." })
  .refine(isCalendarDate, { message: "Datum nije ispravan." });

// Wall-clock time of day, 00:00-23:59.
export const timeString = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, { message: "Vrijeme nije ispravno." });

// End of an availability block (weekly entry or override). Same as
// timeString, plus "24:00" for a block that runs until midnight; slot
// generation handles 1440 minutes. Never use this for a session start.
export const availabilityEndTimeString = z
  .string()
  .regex(/^(([01]\d|2[0-3]):[0-5]\d|24:00)$/, { message: "Vrijeme nije ispravno." });
